// Conversion tracking on top of Pulse (public/pulse.js). The tracker defines
// window.pulse only on public pages that opt in via PulseTracking, and not on
// localhost — everywhere else these calls are silent no-ops. Event names must
// stay in sync with Admin::AnalyticsDataController::CONVERSION_EVENTS /
// CONTACT_CLICK_EVENTS, which the admin funnel reads.
export type ConversionEvent =
  | "enquiry"
  | "consultation_booked"
  | "callback_request"
  | "viewing_request"
  | "newsletter_signup"
  | "call_click"
  | "email_click"
  // Site assistant (not funnel actions — shown on /admin/assistant)
  | "assistant_opened"
  | "assistant_question"
  | "assistant_handoff"
  | "assistant_crisis"

type PulseWindow = { pulse?: (type: string, name: string) => void }

export function trackConversion(name: ConversionEvent) {
  if (typeof window === "undefined") return
  const pulse = (window as PulseWindow).pulse
  if (typeof pulse === "function") pulse("custom", name)
}

// True when an Inertia visit came back clean — redirect_back error responses
// also fire onSuccess, so forms must check this before counting a conversion.
export function visitSucceeded(page: { props: Record<string, unknown> }): boolean {
  const errors = page.props.errors as Record<string, string> | undefined
  return !errors || Object.keys(errors).length === 0
}
